<template src="./UpdateModule.html"></template>
<script>
import SelectFeatureTemplate from "@/components/CommandCellTemplate/SelectFeatureTemplate";
import {notifyWarn} from "@/utils/notification-helper"
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("packageModules");


export default {
  data: function() {
    return {
      skip: 0,
      take: 10,
      pageSize: 10,
      columns: [
        { cell: SelectFeatureTemplate, title: "SELECT", width: "70px" },
        { field: "id", hidden: true, title: "ID" },
        { field: "name", title: "NAME" },
        { field: "type", hidden: true, title: "TYPE" }
      ],
      dataItem: [],
      moduleId: "",
      modulename: this.$store.state.packageModules.editModule.name
    };
  },
  methods: {
    pageChangeHandler: function(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    goToListPage: function() {
      this.$router.push({ name: "PackageModule" });
    },
    getDataOnload: function() {
      this.$store.dispatch("packageModules/getFetaureList");
      this.moduleId = this.$route.params.modId;
    },
    updateModules: async function() {
      var inputElements = document.getElementsByClassName("checkBoxcss");
      var checkedValue = [];

      for (var i = 0; i < inputElements.length; ++i) {
        if (inputElements[i].checked) {
          checkedValue.push({
            ID: Number(inputElements[i].value),
            Name: (this.feature.filter(item =>item.id == Number(inputElements[i].value)))[0]?.name
          });
        }
      }
      if (this.modulename != "") {
        if (checkedValue.length > 0) {
          await this.$store.dispatch("packageModules/updateModule", {
            Name: this.modulename,
            features: checkedValue,
            id: this.$route.params.modId
          });
          this.$router.push({ name: "PackageModule" });
        } else {
          notifyWarn("Select feature!")
        }
      } else {
        notifyWarn("Module name is required.")
      }
    }
  },
  computed: {
    ...mapState({
      feature: state => state.features
    }),
    total() {
      return this.feature.length;
    },
    items: {
      get: function() {
        // return orderBy(
        return this.feature.slice(this.skip, this.take + this.skip);
        // this.sort
        //  );
      }
    }
    // feature: function() {
    //   const feature = this.$store.state.features;
    //   return feature;
    // }
  },
  created: function() {
    this.getDataOnload();
  }
};
</script>



<style scoped >
.selectInput {
  height: 37px;
  background-color: #f9e4e4;
}
</style>

    